const article = {
	slug: "proof-of-work-vs-imposter-syndrome",
	title: "If You Are Waiting to Be a 10, the Market Is Not Waiting With You",
	date: "8 June 2026",
	updated: null,
	description: "A mentoring conversation with a graduating engineer who had the work but had not shown it yet.",
	keywords: ["mentorship", "career advice", "imposter syndrome", "proof of work"],
	tldr: "You do not need a brand name. You need work you can point to. The people worth reaching are not filtering on credentials.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, June 2026.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `Wan Jing Low flew in from Singapore for an evening in New York.

She was not there to talk to Singaporeans.

I was one of several mentors at the Singapore Global Network (SGN) x TalentGeist Work Simulation Program kickoff, organized by Vincent Xu.

Then I sat down with Elren.

NUS biomedical engineer graduating this month. Designed Workato's enterprise MCP course. Built a serious game to help Singaporean youth understand what it feels like to have ADHD, not just what it is. Stanford exchange. NUS International Scholar. Valedictorian. Close to two years of real work before her diploma.

She knew exactly what she wanted to build: UX for biomedical practitioners and consumers. An extension of everything she had already done.

She had not posted on LinkedIn. Worried she could not outshine people who had done UX as their official major.

She said: "They are a 9. I am a 6.7. How do I outshine them?"

I did not have a great answer.

I just told her what took me a long time to learn: the people worth reaching are not filtering on credentials. They want someone who built something real and can explain why it matters.

She had that. In every project.

Wan Jing Low, Deputy Executive Director of Singapore Economic Development Board (EDB), was describing a market with 1.6 vacancies for every job seeker.

Elren was ten feet away, waiting to be a 10.

Elren had the work. She just had not shown it yet.

If you are waiting to be a 10, the market is not waiting with you.`,
};

export default article;
